import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Logo } from "./Logo";
import { NAV, CONTACT, SERVICES } from "../../data/site";

export const Footer = () => (
  <footer className="relative overflow-hidden bg-ink pb-28 pt-20 text-canvas md:pb-10" data-testid="site-footer">
    <div className="wrap">
      <div className="grid gap-12 md:grid-cols-12">
        <div className="md:col-span-5">
          <Logo dark />
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-neutral-300">
            A Canberra marketing agency for businesses with big plans and very little patience for fluff.
          </p>
          <Link to="/contact" className="btn-primary mt-8" data-testid="footer-cta">Book a discovery call <ArrowUpRight className="h-4 w-4" /></Link>
        </div>
        <div className="md:col-span-2">
          <h2 className="text-xs font-semibold uppercase tracking-[0.18em] text-neutral-400">Pages</h2>
          <ul className="mt-5 space-y-3 text-sm">
            {NAV.map((l) => <li key={l.to}><Link to={l.to} className="text-neutral-200 transition-colors hover:text-flame" data-testid={`footer-nav-${l.label.toLowerCase()}`}>{l.label}</Link></li>)}
          </ul>
        </div>
        <div className="md:col-span-2">
          <h2 className="text-xs font-semibold uppercase tracking-[0.18em] text-neutral-400">Services</h2>
          <ul className="mt-5 space-y-3 text-sm">
            {SERVICES.map((s) => <li key={s.slug}><Link to={`/services/${s.slug}`} className="text-neutral-200 transition-colors hover:text-flame">{s.title}</Link></li>)}
          </ul>
        </div>
        <div className="md:col-span-3">
          <h2 className="text-xs font-semibold uppercase tracking-[0.18em] text-neutral-400">Say hello</h2>
          <address className="mt-5 space-y-3 text-sm not-italic text-neutral-200">
            <p>{CONTACT.address}<br />{CONTACT.suburb}</p>
            <p><a href={CONTACT.phoneHref} className="hover:text-flame" data-testid="footer-phone">{CONTACT.phoneDisplay}</a></p>
            <p><a href={`mailto:${CONTACT.email}`} className="hover:text-flame" data-testid="footer-email">{CONTACT.email}</a></p>
          </address>
        </div>
      </div>
      <p className="mt-20 select-none font-display text-[19vw] font-extrabold leading-[0.8] tracking-tighter text-canvas/[0.07] lg:text-[16rem]" aria-hidden="true">catalyst</p>
      <div className="mt-6 flex flex-col justify-between gap-2 border-t border-canvas/10 pt-6 text-xs text-neutral-400 sm:flex-row">
        <p>© {new Date().getFullYear()} The Catalyst. All rights reserved.</p>
        <p>Made in Dickson, ACT.</p>
      </div>
    </div>
  </footer>
);
